import React from 'react'
import pretty from 'pretty-bytes'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'

import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'

import stripeSelectors from 'store/selectors/stripe'
import userSelectors from 'store/selectors/user'
import priceUtils from 'utils/price'

import {
  PRODUCT_FEATURES,
} from 'settings'

const useStyles = makeStyles(theme => ({
  card: {
    
  },
  title: {
    
  },
  subtitle: {
    marginBottom: 12,
  },
  description: {
    
  },
  featureContainer: {
    marginTop: theme.spacing(2),
  },
  featureTitle: {
    textAlign: 'right',
    marginRight: theme.spacing(1),
    fontSize: '0.8em',
  },
  featureContent: {
    textAlign: 'left',
    fontSize: '0.9em',
    fontWeight: '500',
  },
  featureContentIcon: {
    fontSize: '1em',
  },
  tick: {
    color: '#009900',
  },
  cross: {
    color: '#990000',
  },
}))

const Products = ({
  spacing = 1,
  getActions = () => null,
  getCardTheme = () => ({}),
  getFeatures = ({
    product,
  }) => product.metadata
}) => {
  const classes = useStyles()
  
  const currency = useSelector(stripeSelectors.currency)
  const products = useSelector(stripeSelectors.productList)

  return (
    <Grid
      container
      spacing={ spacing }
      direction="row"
      justify="center"
      alignItems="stretch"
    >
      {
        products.map((product) => {

          const cardTheme = getCardTheme({
            product,
          })

          const productFeatures = getFeatures({
            product,
          })

          return (
            <Grid item key={ product.id } xs={ 12 } sm={ 12 } md={ 4 }>
              <Card className={ classnames(classes.card, cardTheme.card) }>
                <CardContent>
                  <Typography className={ classnames(classes.title, cardTheme.title) } variant="h6" component="h2">
                    { product.name }
                  </Typography>
                  <Typography className={ classnames(classes.subtitle, cardTheme.subtitle) } color="textSecondary">
                    { currency.symbol }{ priceUtils.displayPrice(product.price.unit_amount) } per month
                  </Typography>
                  <Typography className={ classnames(classes.description, cardTheme.description) } variant="body2" component="p">
                    { product.description }
                  </Typography>
                  <div className={ classes.featureContainer }>
                    <Grid container spacing={ 0 }>
                      {
                        PRODUCT_FEATURES.map(feature => {
                          const value = productFeatures[feature.id]
                          let content = value
                          
                          if(feature.type == 'tick') {
                            content = value == 'on' ?
                              <span className={ classes.tick }>✔</span> :
                              <span className={ classes.cross }>✗</span>
                          }
                          else if(feature.type == 'bytes') {
                            content = pretty(content)
                          }

                          const contentClassname = classnames(classes.featureContent, {
                            [classes.featureContentIcon]: feature.type == 'tick',
                          })

                          return (
                            <React.Fragment key={ feature.id }>
                              <Grid item xs={ 6 }>
                                <Tooltip title={ feature.description } placement="top">
                                  <div className={ classes.featureTitle }>
                                    { feature.title }:
                                  </div>
                                </Tooltip>
                              </Grid>
                              <Grid item xs={ 6 }>
                                <Tooltip title={ feature.description } placement="top">
                                  <div className={ contentClassname }>
                                    { content } { feature.append || '' }
                                  </div>
                                </Tooltip>
                              </Grid>
                            </React.Fragment>
                          )
                        })
                      }
                    </Grid>
                  </div>
                </CardContent>
                <CardActions>
                  {
                    getActions({
                      product,
                    })
                  }
                </CardActions>
              </Card>
            </Grid>
          )
        })
      }
    </Grid>
  )
}

export default Products